import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SkuService {

  constructor(private http: HttpClient) { }

  getVendorCategoryOptions(): Observable<any> {
    const url = `${environment.logisticsApiUrl}/sku/getVendorCategoryOptions`;
    return this.http.post(url, null);
  }
}
